import Logo from "../../../assets/images/svg/logo/utivacolored.svg";
import { ArrowUpRight } from "../../../components/svgs";

const CourseCertificateSection = ({ courses, selectedCourseData }) => {
  const course = courses?.find((a) => a?.title === selectedCourseData?.title);
  const enrolLink = course?.enrolLink || "/";

  return (
    <section
      id="certificate"
      className="bg-[#F0F5FF] border-y border-[#DFE6F7] py-16 md:py-24"
    >
      <div className="max-w-[1260px] mx-auto px-4">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="relative pb-20 lg:flex-1">
            <div className="relative border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-feature p-7 md:p-9 pl-12 md:pl-16 overflow-hidden min-h-[380px] flex flex-col">
              {/* <span className="absolute inset-y-0 -left-24 w-40 bg-secondary rounded-[50px] pointer-events-none" /> */}
              <span
                className="absolute h-full bg-secondary pointer-events-none"
                style={{
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: "-60px",
                  width: "120px",
                  height: "100%",
                  borderRadius: "50%",
                }}
              />
              <span className="absolute -top-20 -right-16 w-36 h-36 rounded-full border-[28px] border-primary pointer-events-none" />

              <div className="relative flex items-center justify-between mb-5">
                <img src={Logo} alt="Utiva" className="w-14 md:w-16" />
                <strong className="text-primary text-3xl md:text-4xl tracking-wide">
                  DIPLOMA
                </strong>
              </div>

              <p className="relative text-primary font-bold text-base mb-6">
                ACCREDITED BY ACTD
              </p>

              <small className="relative text-[#565656] text-[14px] mb-1">
                This certificate of graduation is presented to
              </small>
              <h3 className="relative text-[#1E2027] text-2xl md:text-4xl  border-b-2 border-primary pb-3 mb-4 max-w-[85%]">
                Your name
              </h3>

              <div className="relative flex flex-col gap-1 text-[14px] text-[#565656]">
                <span>for completing the</span>
                <strong className="text-primary text-base">
                  {selectedCourseData?.title}
                </strong>
              </div>

              <div className="relative flex items-center justify-between mt-auto pt-6">
                <small className="text-[14px] text-[#565656]">
                  Credential ID · Completion date
                </small>
                <span className="flex-none w-10 h-10 rounded-full bg-primary text-secondary grid place-items-center text-lg font-black">
                  ✓
                </span>
              </div>
            </div>

            <div className="absolute left-5 right-5 -bottom-3 md:bottom-0 z-[3] flex items-center gap-4 bg-primary border-2 border-secondary rounded-2xl px-5 py-4 shadow-course-lockup">
              <span className="flex-none w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-secondary text-secondary grid place-items-center text-[14px] font-extrabold">
                ACTD
              </span>
              <div>
                <small className="text-secondary tracking-wider text-[14px] block">
                  ACCREDITED CREDENTIAL
                </small>
                <strong className="text-white text-[16px] block my-0.5">
                  Certificate + accreditation
                </strong>
                <p className="text-[#F0F5FF] text-[14px] m-0">
                  Issued with a unique credential ID and online validation.
                </p>
              </div>
            </div>
          </div>

          <div className="pt-6 lg:pt-0 lg:flex-1">
            <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold flex items-center gap-2 mb-4">
              <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
              Proof of progress
            </p>
            <h2 className="text-primary font-bold text-3xl md:text-4xl tracking-tight mb-5 max-w-[500px]">
              {selectedCourseData?.certification?.title ||
                "Earn a Utiva Certification"}
            </h2>
            <p className="text-[#565656] text-sm md:text-lg leading-relaxed">
              {selectedCourseData?.certification?.description}
            </p>

            <ul className="grid gap-3 mt-6 mb-8">
              <li className="text-base text-[#1E2027] flex gap-2">
                <span className="text-primary font-extrabold">✓</span>
                ACTD-accredited diploma
              </li>
              <li className="text-base text-[#1E2027] flex gap-2">
                <span className="text-primary font-extrabold">✓</span>
                Unique verifiable credential ID
              </li>
              <li className="text-base text-[#1E2027] flex gap-2">
                <span className="text-primary font-extrabold">✓</span>
                Formatted for LinkedIn sharing
              </li>
            </ul>

            <a
              href={enrolLink}
              target="_blank"
              rel="noopener noreferrer"
              className="custom-btn custom-btn-with-shadow-primary inline-flex items-center gap-3 bg-primary text-white font-bold text-sm rounded-xl px-8 py-4 focus:outline-none"
            >
              Enrol now{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseCertificateSection;
